import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export const saveHomeworkCoachTemp = (param: {
    data: Record<string, any>;
    parent_type: string;
}): Promise<IResponse<{ id: string }>> => {
    return fetchData(Api.POST_POLL, {
        parent_type: param.parent_type,
        data: JSON.stringify(param.data),
    });
};
